const categories = [
    {
      name: 'all',
      text: '전체',
    },
    {
      name: 'accept',
      text: '접수',
    },
    {
      name: 'deliver',
      text: '배송중',
    },
    {
      name: 'cancel',
      text: '취소',
    }
];

export default categories;